import { render, staticRenderFns } from "./category-dialog.vue?vue&type=template&id=0c897d74&scoped=true&"
import script from "./category-dialog.vue?vue&type=script&lang=js&"
export * from "./category-dialog.vue?vue&type=script&lang=js&"
import style0 from "./category-dialog.vue?vue&type=style&index=0&id=0c897d74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c897d74",
  null
  
)

export default component.exports